import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import queryString from "query-string";
import dayjs from "dayjs";

import { apiRequest } from "../../../hooks/apiRequest";
import { formatCurrency } from "../../../utils/helpers";
import { auth } from "../../../utils/auth";

const Comisiones = () => {
    const { id } = useParams();
    const [nomina, setNomina] = useState(null);
    const [orden, setOrden] = useState('nombre');
    const [redondear, setRedondear] = useState(false);
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        getNomina();
        getCategorias();
    }, []);

    const getNomina = async (url = null) => {
        url = url ? url : `nominas/${id}?detalles=true`;
        const response = await apiRequest(null, url, "get");

        if (response?.success) {
            setNomina(response.data[0]);
        }
    };

    const getCategorias = async () => {
        const url = `grupos`;
        const response = await apiRequest(null, url, "get")

        if (response.data) {
            setCategorias(response.data);
        }
    };

    const onChangeOrden = (e) => {
        setOrden(e.target.value);
    };

    const onChangeRedondear = () => {
        setRedondear(prev => !prev);
    };

    const redondearCantidad = (cantidad) => {
        return Math.round(cantidad / 5) * 5;
    };

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];
    const query = queryString.parse(window.location.search);

    return (
        <div>
            <style>{`@page {size: 11in  8.5in;} *{font-size: 14px}`}</style>
            <div className='row'>
                {nomina?.cerradaEn && (
                    <div className='fecha_cierre col-md-12'>
                        Nomina Cerrada:{" "}
                        {dayjs(nomina?.cerradaEn).format("DD/MM/YYYY")}
                    </div>
                )}
                <h3 className='col-md-12 text-center m-b-5'>
                    Detalle de {nomina?.nombre} {" "}
                    {query.contrato === "informal" ? "Informales" : ""}
                </h3>
                <div className='col-md-12 text-center'>
                    {sucursal.nombre} - {sucursal.direccion} •{" "}
                    {dayjs(nomina?.desde || nomina?.fechaInicio).format("DD/MM/YYYY")} -{" "}
                    {dayjs(nomina?.hasta || nomina?.fechaCierre).format("DD/MM/YYYY")}
                </div>
            </div>
            <div className='row text-right mb-3'>
                <div className='col text-left'>
                    {nomina?.settings?.tipo_comision === "Categorías" ? (
                        <>
                            <div>PAGOS: {nomina?.pagos?.length}</div>
                            <div>
                                PORCENTAJES: GENERAL: {nomina?.porcentaje}% - {nomina?.settings?.categorias?.map((categoria) => `${categorias.find((c) => c.id == categoria.id)?.nombre}: ${categoria.porcentaje}%`).join(" - ")}
                            </div>
                            <div>
                                {nomina?.settings.incluir_impuestos === 'true' ? 'Incluye Impuestos' : 'NO Incluye Impuestos'} | {nomina?.settings.ventas === 'true' ? 'Comisión por Ventas' : 'Comisión por Cobros'} | {nomina?.settings.dias_vencimiento ? `Excluyendo Vencidas (+${nomina?.settings.dias_vencimiento} días)` : 'Incluye Vencidas' }
                            </div>
                        </>
                    ) : (
                        <>TRANSACCIONES: {nomina?.transacciones?.length} - PORCENTAJE COMISIÓN: {nomina?.porcentaje}%</>
                    )}
                </div>
            </div>
            {nomina?.pagos?.map(pago => (
                <div key={pago.id} style={{pageBreakAfter: 'always'}}>
                    <div>
                        <h3 className="pb-3">
                            <div className='float-left'>
                                EMPLEADO: {pago.codigo} - {pago.empleado}
                            </div>
                            <div className="float-right">
                                TOTAL: {formatCurrency(pago.total)}
                            </div>
                        </h3>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Cliente</th>
                                    <th>NFC/Número</th>
                                    <th>Fecha</th>
                                    <th className="text-right">Subtotal</th>
                                    <th className="text-right">Impuesto</th>
                                    <th className="text-right">N. Crédito</th>
                                    <th className="text-right">Total</th>
                                    <th className='text-right'>Comisión</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pago.transacciones?.map((transaccion, index) => (
                                    <tr key={index} className={transaccion.vencida ? 'strike-row' : ''}>
                                        <td>{transaccion.cliente}</td>
                                        <td>{transaccion.numero}</td>
                                        <td>{transaccion.fecha}</td>
                                        <td className="text-right">{formatCurrency(transaccion.subtotal)}</td>
                                        <td className="text-right">{formatCurrency(transaccion.monto - transaccion.subtotal)}</td>
                                        <td className="text-right">{formatCurrency(transaccion.notas_credito)}</td>
                                        <td className="text-right">{formatCurrency(transaccion.monto)}</td>
                                        <td className="text-right">{formatCurrency(transaccion.comision)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='row'>
                        <div className='col-md-12 text-right p-t-10 p-b-10'>
                            <div className='float-left'>
                                TRANSACCIONES: {pago.transacciones?.length}
                            </div>

                            <div className='float-right'>
                                <h3>TOTAL: {formatCurrency(pago.total)}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Comisiones;
